import allowedCookies from "../constants/cookies";
import Cookies from "js-cookie";

const getCookie = (name: (typeof allowedCookies)[number]) => Cookies.get(name);

export default getCookie;
